import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BlockDirective, ElemDirective } from '@rt-tools/core';
import { RtButtonDirective, RtDialogComponent, RtDialogRef } from '@rt-tools/ui-kit-v2';

const BEM_BLOCK: string = 'sc-sign-in-modal';

@Component({
    selector: 'sc-sign-in-modal',
    templateUrl: './sign-in-modal.component.html',
    styleUrl: './sign-in-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // rt-tools
        BlockDirective,
        ElemDirective,

        // rt-tools ui-kit
        RtButtonDirective,
        RtDialogComponent,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class SignInModalComponent {
    readonly #ref: RtDialogRef<boolean> = inject<RtDialogRef<boolean>>(RtDialogRef);

    protected confirm(): void {
        this.#ref.close(true);
    }

    protected cancel(): void {
        this.#ref.close(false);
    }
}
